export default "__VITE_ASSET__Bg4w$fgw__"